$('.qlist.singleop').on('click', 'li', function() {
  $(this).addClass('active').siblings().removeClass('active').addClass('notactive');
});
 
$('.third .qlist li').click(function() {
    $(this).toggleClass("active");
  });
 

$('#tquiz.mobile .qbox.first a').click(function() {
 	 $('#tquiz.mobile .qbox.first').fadeOut();
  $('#tquiz.mobile .qbox.second').delay(300).fadeIn();

  });
 
$('#tquiz.mobile .qbox.second a').click(function() {
 	 $('#tquiz.mobile .qbox.second').fadeOut();
  $('#tquiz.mobile .qbox.third').delay(300).fadeIn();
  $('#tquiz.mobile .next').delay(300).fadeIn();

  });
 


$('.xxx').click(function() {
    var $group = $(this).closest('.colors');
    $('.color', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.one').fadeOut();
  $('.slide.two').delay(300).fadeIn();
  slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
  $(".progbar div").removeClass();
  $(".progbar div").addClass("bar two");
  });
 